import React from 'react'
import { Container, Col, Row } from 'react-grid-system'

import InfoAtendimento from 'assets/svg/info_atendimento.svg'
import InfoProposal from 'assets/svg/info_proposta.svg'

import { TagPushHome } from 'analytics/home'

import InfoPanel from '../InfoPanel'

import './InfosContainer.scss'

const InfosContainer = ({ bankName }) => (
    <div className="infos-container">
        <Container className="infos-container__container">
            <Row>
                <Col
                    className="infos-container__column"
                    offset={{ lg: 2, md: 2, xl: 2 }}
                    xl={4}
                    lg={4}
                    md={4}
                    sm={12}
                >
                    <InfoPanel
                        icon={InfoAtendimento}
                        title="Central de atendimento"
                        description="Ligue para a nossa Central de Vendas."
                        link="https://www.alelo.com.br/empresas/telefone"
                        onClick={() =>
                            TagPushHome.interactionLink(
                                bankName,
                                'Central de atendimento'
                            )
                        }
                        gtmCategory="alelo:loja-virtual"
                        gtmAction="clique:atendimento"
                        gtmLabel="central-de-atendimento"
                    />
                </Col>
                <Col
                    className="infos-container__column"
                    xl={4}
                    lg={4}
                    md={4}
                    sm={12}
                >
                    <InfoPanel
                        icon={InfoProposal}
                        title="Solicite uma proposta comercial"
                        description="Escolha o produto de seu interesse e entramos em contato com uma proposta personalizada."
                        onClick={() =>
                            TagPushHome.interactionLink(
                                bankName,
                                'Solicite uma proposta comercial'
                            )
                        }
                        link="https://www.alelo.com.br/empresas/soliciteproposta"
                        gtmCategory="alelo:loja-virtual"
                        gtmAction="clique:atendimento"
                        gtmLabel="solicite-uma-proposta-comercial"
                    />
                </Col>
            </Row>
        </Container>
    </div>
)

export default InfosContainer
